module.exports = __webpack_public_path__ + "img/05solidworks.02803a36.jpg";